"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverArrow = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const PopoverArrowComponent = (props) => (React.createElement(react_core_1.Box, Object.assign({}, props),
    React.createElement("svg", { viewBox: "0 0 30 30" },
        React.createElement("path", { className: "stroke", d: "M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26\n        C26.7,29,24.6,28.1,23.7,27.1z" }),
        React.createElement("path", { className: "fill", d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z" }))));
const popoverTheme = styled_tools_1.theme('PopoverArrow');
exports.PopoverArrow = styled_1.default(PopoverArrowComponent) `
  position: absolute;
  font-size: 30px;
  width: 1em;
  height: 1em;
  pointer-events: none;
  background-color: transparent;
  border-color: ${styled_tools_1.prop('theme.gray5')};
  color: ${styled_tools_1.prop('theme.gray5')};

  &&& > svg > path {
    fill: currentColor;
  }

  & .stroke {
    fill: ${styled_tools_1.prop('strokeColor')};
  }

  & .fill {
    fill: ${styled_tools_1.prop('fillColor', react_core_1.bgColorWithProps)};
  }

  [data-placement^='top'] > & {
    top: 100%;
    transform: rotateZ(180deg);
  }

  [data-placement^='right'] > & {
    right: 100%;
    transform: rotateZ(-90deg);
  }

  [data-placement^='bottom'] > & {
    bottom: 100%;
    transform: rotateZ(360deg);
  }

  [data-placement^='left'] > & {
    left: 100%;
    transform: rotateZ(90deg);
  }

  ${popoverTheme};
`;
exports.PopoverArrow.defaultProps = {
    strokeColor: 'transparent',
    opaque: true,
    palette: 'white',
};

//# sourceMappingURL=PopoverArrow.js.map
